import { render, staticRenderFns } from "./AccessSystem.vue?vue&type=template&id=0649fe0e&"
import script from "./AccessSystem.vue?vue&type=script&lang=js&"
export * from "./AccessSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports